import { __extends } from "tslib";
import { Event } from './Event';
import { EventDispatcherBase } from './EventDispatcherBase';
import { UUID } from '@awayjs/core';
import { release } from '@awayfl/swf-loader';
import { assert } from '@awayjs/graphics';
import { MouseEvent } from '../events/MouseEvent';
import { Settings } from '@awayfl/avm2';
/**
     * [broadcast event] Dispatched when the Flash Player or AIR application operating
     * loses system focus and is becoming inactive.
     * @eventType	flash.events.Event.DEACTIVATE
    [Event(name="deactivate", type="flash.events.Event")]

     * [broadcast event] Dispatched when the Flash Player or AIR application gains
     * operating system focus and becomes active.
     * @eventType	flash.events.Event.ACTIVATE
    [Event(name="activate", type="flash.events.Event")]
 */
var EventDispatcher = /** @class */ (function (_super) {
    __extends(EventDispatcher, _super);
    function EventDispatcher(target) {
        if (target === void 0) { target = null; }
        var _this = _super.call(this, target) || this;
        _this.id = UUID.Next();
        _this.eventMapping || (_this.eventMapping = {});
        _this.eventMappingDummys || (_this.eventMappingDummys = {});
        _this.eventMappingExtern || (_this.eventMappingExtern = {});
        _this.eventMappingInvert || (_this.eventMappingInvert = {});
        _this._activateCallbackDelegate = function (event) { return _this.activateCallback(event); };
        _this.eventMapping[Event.ACTIVATE] = {
            adaptedType: '',
            addListener: _this.initActivateListener,
            removeListener: _this.removeActivateListener,
            callback: _this._activateCallbackDelegate
        };
        _this._deactivateCallbackDelegate = function (event) { return _this.deactivateCallback(event); };
        _this.eventMapping[Event.DEACTIVATE] = {
            adaptedType: '',
            addListener: _this.initDeactivateListener,
            removeListener: _this.removeDeactivateListener,
            callback: _this._deactivateCallbackDelegate
        };
        return _this;
    }
    EventDispatcher.prototype.toString = function () {
        return '';
    };
    EventDispatcher.prototype.hasEventListener = function (type, listener) {
        return _super.prototype.hasEventListener.call(this, type, listener);
    };
    EventDispatcher.prototype.willTrigger = function () {
    };
    EventDispatcher.prototype.dispatchEvent = function (event, comesFromAway) {
        if (comesFromAway === void 0) { comesFromAway = false; }
        event.currentTarget = this;
        if (event.type == 'enterFrame') { //} || event.type=="scroll"){
            event.target = this;
        }
        var returnVal = _super.prototype.dispatchEvent.call(this, event);
        // workaround for now.
        // mousevents already bubble up the scenegraph in MouseMangager
        // for all other events, we want to bubble them up here:
        if (!comesFromAway && EventDispatcher.eventsThatBubbleInAwayJS.indexOf(event.type) == -1) {
            if (this.adaptee && this.adaptee.parent) {
                this.adaptee.parent.adapter.dispatchEvent(event);
            }
        }
        return returnVal;
    };
    // ---------- event mapping functions Event.ACTIVATE
    EventDispatcher.prototype.initActivateListener = function (type, callback) {
        window.onfocus = callback;
    };
    EventDispatcher.prototype.removeActivateListener = function (type, callback) {
        window.onfocus = null;
    };
    EventDispatcher.prototype.activateCallback = function (event) {
        if (event === void 0) { event = null; }
        this.dispatchEvent(new this.sec.flash.events.Event(Event.ACTIVATE));
    };
    // ---------- event mapping functions Event.DEACTIVATE
    EventDispatcher.prototype.initDeactivateListener = function (type, callback) {
        window.onblur = callback;
    };
    EventDispatcher.prototype.removeDeactivateListener = function (type, callback) {
        window.onblur = null;
    };
    EventDispatcher.prototype.deactivateCallback = function (event) {
        if (event === void 0) { event = null; }
        this.dispatchEvent(new this.sec.flash.events.Event(Event.DEACTIVATE));
    };
    /*overwrite*/
    EventDispatcher.prototype.addEventListener = function (type, listener, useCapture, priority, useWeakReference) {
        if (useCapture === void 0) { useCapture = false; }
        if (priority === void 0) { priority = 0; }
        if (useWeakReference === void 0) { useWeakReference = false; }
        if (!useCapture && Event.isBroadcastEventType(type)) {
            BroadcastEventDispatchQueue.getInstance().add(type, this);
        }
        this.eventMapping || (this.eventMapping = {});
        this.eventMappingDummys || (this.eventMappingDummys = {});
        this.eventMappingExtern || (this.eventMappingExtern = {});
        this.eventMappingInvert || (this.eventMappingInvert = {});
        if (this.eventMappingDummys.hasOwnProperty(type)) {
            // this is a dummy eventMapping
            // this means that this is a event-type, that is not yet supported
            // we do not need to register it on superclass
            // for now we output a warning
            //console.log("Warning - EventDispatcher:  trying to listen for unsupported event: :
            //"+this.eventMappingDummys[type]);
            return;
        }
        else if (this.eventMapping.hasOwnProperty(type)) {
            // a mapping exists for this event
            //making sure standart behaviour still works (listener is tracked in list)
            _super.prototype.addEventListener.call(this, type, listener, useCapture, priority, useWeakReference);
            // call the provided "addListener" function
            this.eventMapping[type].addListener.call(this, this.eventMapping[type].adaptedType, this.eventMapping[type].callback, listener);
            return;
        }
        else {
            // this is a external eventMapping
            // this means that we do not need to create any mapping, and will manually dispatch the event
            // we still need to register it on superclass, so it will work if we dispatch it manually
            _super.prototype.addEventListener.call(this, type, listener, useCapture, priority, useWeakReference);
            return;
        }
        // if we make it here, the event is not handled by this dispatcher
        // lets output a Warning for now.
        //console.log("EventDispatcher: trying to listen for unknown event: '"+type+"'")
    };
    /**
     * Remove an event listener
     * @method removeEventListener
     * @param {String} type of event to remove a listener for
     * @param {Function} listener function
     */
    EventDispatcher.prototype.removeEventListener = function (type, listener) {
        this.eventMapping || (this.eventMapping = {});
        this.eventMappingDummys || (this.eventMappingDummys = {});
        this.eventMappingExtern || (this.eventMappingExtern = {});
        this.eventMappingInvert || (this.eventMappingInvert = {});
        _super.prototype.removeEventListener.call(this, type, listener);
        if (this.eventMapping.hasOwnProperty(type)) {
            // a mapping exists
            this.eventMapping[type].removeListener.call(this, this.eventMapping[type].adaptedType, this.eventMapping[type].callback, listener);
            if (!this.hasEventListener(type)) {
                if (Event.isBroadcastEventType(type)) {
                    BroadcastEventDispatchQueue.getInstance().remove(type, this);
                }
            }
        }
    };
    EventDispatcher.eventsThatBubbleInAwayJS = [
        MouseEvent.MOUSE_WHEEL,
        MouseEvent.MOUSE_UP,
        MouseEvent.MOUSE_OVER,
        MouseEvent.MOUSE_OUT,
        MouseEvent.ROLL_OVER,
        MouseEvent.ROLL_OUT,
        MouseEvent.MOUSE_MOVE,
        MouseEvent.MOUSE_DOWN,
        MouseEvent.DOUBLE_CLICK,
        MouseEvent.CLICK,
        Event.ENTER_FRAME,
        Event.EXIT_FRAME,
        Event.FRAME_CONSTRUCTED,
        Event.ADDED_TO_STAGE,
        Event.RESIZE,
        Event.REMOVED_FROM_STAGE,
        //KeyboardEvent.KEY_DOWN,
        //KeyboardEvent.KEY_UP,
    ];
    return EventDispatcher;
}(EventDispatcherBase));
export { EventDispatcher };
var USE_WEAK = ('WeakRef' in self) && Settings.USE_WEAK_REF;
if (USE_WEAK) {
    console.debug('[BroadcastEventDispatchQueue] `WeakRef` used for Broadcast Events!');
}
var BroadcastEventDispatchQueue = /** @class */ (function () {
    function BroadcastEventDispatchQueue() {
        /**
         * The queues start off compact but can have null values if event targets are removed.
         * Periodically we compact them if too many null values exist.
         */
        this._queues = {};
    }
    BroadcastEventDispatchQueue.getInstance = function () {
        return BroadcastEventDispatchQueue._instance
            || (BroadcastEventDispatchQueue._instance = new BroadcastEventDispatchQueue());
    };
    BroadcastEventDispatchQueue.prototype.add = function (type, target) {
        // release || assert(Event.isBroadcastEventType(type), "Can only register broadcast events.");
        var queue = this._queues[type] || (this._queues[type] = []);
        if (queue[target.id])
            return;
        queue[target.id] = (USE_WEAK ? new self.WeakRef(target) : target);
    };
    BroadcastEventDispatchQueue.prototype.remove = function (type, target) {
        //release || assert (Event.isBroadcastEventType(type), "Can only unregister broadcast events.");
        var queue = this._queues[type];
        release || assert(queue, 'There should already be a queue for this.');
        delete queue[target.id];
    };
    BroadcastEventDispatchQueue.prototype.dispatchEvent = function (event) {
        //release || assert (event.isBroadcastEvent(), "Cannot dispatch non-broadcast events.");
        var queue = this._queues[event._type];
        //return if no listeners exist for event type
        if (!queue)
            return;
        for (var key in queue) {
            var target = queue[key];
            if (USE_WEAK)
                target = target === null || target === void 0 ? void 0 : target.deref();
            if (target) {
                target.dispatchEvent(event);
            }
            else {
                console.debug('[BroadcastEventDispatchQueue] Broadcast target was deleted by GC:', key);
                delete queue[key];
            }
        }
    };
    BroadcastEventDispatchQueue.prototype.getQueueLength = function (type) {
        return this._queues[type] ? Object.getOwnPropertyNames(this._queues[type]).length : 0;
    };
    return BroadcastEventDispatchQueue;
}());
export { BroadcastEventDispatchQueue };
